import React, { useState, useEffect } from "react";

const C = {
  bg: "#ffffff",
  bgAlt: "#f8f9fb",
  bgHeader: "#1e3a5f",
  text: "#1e293b",
  textMuted: "#94a3b8",
  accent: "#2563eb",
  border: "#e2e8f0",
  current: "#10b981",
};

const Modern = ({ zmanimList = [], title, showTitle = true, hebrewDate, countdown }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(t);
  }, []);

  const dayName = now.toLocaleDateString("he-IL", { weekday: "long" });
  const dateLabel = hebrewDate?.hebrewShort ? `${dayName} ${hebrewDate.hebrewShort}` : dayName;
  const hhmm = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

  return (
    <div style={{
      direction: "rtl", width: "100%", height: "100%",
      backgroundColor: C.bg, overflow: "hidden",
      display: "flex", flexDirection: "column",
      fontFamily: "inherit",
    }}>
      {showTitle && (
        <div style={{
          backgroundColor: C.bgHeader,
          padding: "0.8rem 1.5rem",
          display: "flex", justifyContent: "space-between", alignItems: "center",
          flexShrink: 0, flexWrap: "wrap", gap: "4px",
        }}>
          <span style={{ color: "#fff", fontWeight: 700, fontSize: "1.2em" }}>{title}</span>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ color: "#94a3b8", fontSize: "0.85em" }}>{dateLabel}</span>
            {countdown && (
              <div style={{ display: "flex", alignItems: "center", gap: "5px", backgroundColor: "rgba(255,255,255,0.12)", padding: "3px 10px", borderRadius: "12px" }}>
                <span style={{ color: "#94a3b8", fontSize: "0.75em" }}>{countdown.label}</span>
                <span style={{ color: "#fbbf24", fontSize: "0.9em", fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>{countdown.remaining}</span>
              </div>
            )}
          </div>
        </div>
      )}

      <div style={{ flex: 1, overflow: "auto" }}>
        {zmanimList.map((item, i) => {
          const toMinAdj = t => { const [h, m] = t.split(":").map(Number); return (h === 0 ? 24 : h) * 60 + m; };
          const isPast = toMinAdj(item.time) < toMinAdj(hhmm);
          const isCurrent = item.time === hhmm;
          return (
            <div key={item.key} style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "0.55rem 1.2rem",
              opacity: isPast ? 0.65 : 1,
              backgroundColor: isCurrent ? `${C.current}0c` : (i % 2 === 0 ? C.bg : C.bgAlt),
              borderRight: isCurrent ? `3px solid ${C.current}` : "3px solid transparent",
              borderBottom: `1px solid ${C.border}60`,
            }}>
              <span style={{
                color: isCurrent ? C.current : C.text,
                fontSize: "0.95em", fontWeight: isCurrent ? 700 : 500,
                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                flex: 1, minWidth: 0,
              }}>{item.label}</span>
              <span style={{
                color: isCurrent ? C.current : C.accent,
                fontSize: "1em", fontWeight: 700,
                fontVariantNumeric: "tabular-nums", flexShrink: 0, marginRight: "12px",
              }}>{item.time}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Modern;
